import { useMutation } from 'react-query';
import {
  createSponteIntegrationAsync,
  deleteSponteIntegrationAsync,
  getAllSponteIntegrationsAsync,
  getSponteIntegrationByIdAsync,
  updateSponteIntegrationAsync,
} from '../../index';

export const useCreateSponteIntegrationAsync = () =>
  useMutation(createSponteIntegrationAsync);

export const useGetSponteIntegrationByIdAsync = () =>
  useMutation(getSponteIntegrationByIdAsync);

export const useGetAllSponteIntegrationsAsync = () =>
  useMutation(getAllSponteIntegrationsAsync);

export const useUpdateSponteIntegrationAsync = () =>
  useMutation(updateSponteIntegrationAsync);

export const useDeleteSponteIntegrationAsync = () =>
  useMutation(deleteSponteIntegrationAsync);
